import React from 'react';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';
import { ValidatingInput, ValidationScope, ValidatingTextArea } from '@/components/forms/validation';
import { useValidationManager } from '@/utils/hooks';
import { ApproveExternalAgreementChangeRequestOptions } from '@/services/external-agreements';
import InfoIconWithTooltip from '@/seller/components/InfoIconWithTooltip';
import MandatoryIndicator from '@/components/forms/MandatoryIndicator';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';

interface ExternalAgreementApproveWizardChangeRequestProps {
    projectId: number;
    value: ApproveExternalAgreementChangeRequestOptions;
    onChange(data: ApproveExternalAgreementChangeRequestOptions): void;
}

const ExternalAgreementApproveWizardChangeRequest: React.FC<ExternalAgreementApproveWizardChangeRequestProps> = ({
    projectId,
    value,
    onChange,
}) => {
    const triggerChange = (changes: Partial<ApproveExternalAgreementChangeRequestOptions>) => {
        triggerHandler(onChange, { ...value, ...changes });
    };

    const validationManager = useValidationManager();

    return (
        <ValidationScope validationManager={validationManager}>
            <div className="form columns-1">
                <label>
                    <Trans>Title</Trans>
                    <MandatoryIndicator />
                    <InfoIconWithTooltip
                        color="light"
                        title={<Trans>Title</Trans>}
                        content={<Trans>Please note, this message will be visible to the buyer.</Trans>}
                    />
                    <ValidatingInput
                        placeholder={t`Subject`}
                        required
                        className="form-control"
                        value={value.subject}
                        onChange={(e) => triggerChange({ subject: e.target.value })}
                    />
                </label>
                <div className="form-label">
                    <Trans>Description</Trans>
                    <InfoIconWithTooltip
                        color="light"
                        title={<Trans>Description</Trans>}
                        content={<Trans>Please note, this message will be visible to the buyer.</Trans>}
                    />
                    <ValidatingTextArea
                        placeholder={t`The description for the agreement will be visible to the buyer.`}
                        fieldName={t`Description`}
                        className="form-control"
                        autoResize
                        minRows={4}
                        value={value.description}
                        onChange={(e) => triggerChange({ description: e.target.value })}
                    />
                </div>
                <div className="form-label">
                    <Trans>Internal description</Trans>
                    <InfoIconWithTooltip
                        color="light"
                        title={<Trans>Internal description</Trans>}
                        content={<Trans>Please note, not visible to buyers.</Trans>}
                    />
                    <ValidatingTextArea
                        placeholder={t`The description for the agreement not will be visible to the buyer.`}
                        fieldName={t`Description`}
                        className="form-control"
                        autoResize
                        minRows={4}
                        value={value.internalDescription}
                        onChange={(e) => triggerChange({ internalDescription: e.target.value })}
                    />
                </div>
            </div>
        </ValidationScope>
    );
};

export default ExternalAgreementApproveWizardChangeRequest;
